import { MockedRequest, RestHandler, rest } from "msw";

import { MOCK_VERSION_RESPONSE } from "../fixtures/sessionFixtures";

export const versionHandler = (
  status = 200,
  response = MOCK_VERSION_RESPONSE
): RestHandler<MockedRequest<{} | null>> => {
  return rest.get("/version", (_req, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const versionHandlers = [versionHandler(200)];
